import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from '../../../utils/useTranslation';
import { IconRubInCircle } from '../../icon/IconRubInCircle';
import { IconRubInCircleFilled } from '../../icon/IconRubInCircleFilled';
import { Typography } from '../../typography/Typography';
import { ADVERTISING_CATALOG_URL, CATALOG_URLS } from './constants';
import { Button, Wrapper } from './styles';
import type { AdvertisingMenuButtonProps } from './types';

export const AdvertisingMenuButton: React.FC<AdvertisingMenuButtonProps> = ({
    text,
    target = '_blank',
}) => {
    const t = useTranslation();
    const { pathname } = useLocation();
    const isActive = CATALOG_URLS.includes(pathname);

    return (
        <Wrapper>
            <Button as={NavLink} target={target} to={ADVERTISING_CATALOG_URL}>
                {isActive ? <IconRubInCircleFilled size={24} /> : <IconRubInCircle size={24} />}
                <Typography
                    variant="body"
                    weight="bold"
                    textTransform="none"
                    color="inherit"
                    display={{ xs: 'none', lg: 'initial' }}
                >
                    {text ?? t('Монетизация')}
                </Typography>
            </Button>
        </Wrapper>
    );
};
